import CMSWrapper from '@/features/shared/CMSWrapper';
import ContentContainer from '@/features/shared/ContentContainer';
import { MuiContainer } from '@/features/shared/material-ui';
import { resolveColorName, resolveImageReference, resolveSpacingSize } from '@/utils/resolvers';
import React, { useMemo, useRef } from 'react';
import Video from './Video';

const MappedVideo = ({ presentation, fallbackImage }: any) => {
  const {
    topSpacing,
    bottomSpacing,
    containerTopBackgroundColor,
    containerBottomBackgroundColor,
    isFullBleed,
  } = presentation;
  const containerProps = useMemo(
    () => ({
      topSpacing,
      bottomSpacing,
      topBackgroundColor: containerTopBackgroundColor,
      bottomBackgroundColor: containerBottomBackgroundColor,
    }),
    [bottomSpacing, containerBottomBackgroundColor, containerTopBackgroundColor, topSpacing],
  );

  return (
    <div data-datalayer-position="video" data-datalayer-variant={presentation?.datalayerVariant}>
      {isFullBleed ? (
        <Video {...presentation} fallbackImage={fallbackImage} />
      ) : (
        <ContentContainer {...containerProps}>
          <MuiContainer className="medium" data-testid="qa-video-container">
            <Video {...presentation} fallbackImage={fallbackImage} />
          </MuiContainer>
        </ContentContainer>
      )}
    </div>
  );
};

const resolveTemplate = ({ rawVal }: any) => rawVal && rawVal === 'full-bleed';

const VideoCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    componentParameterMap: [
      'presentation',
      {
        'video-id': 'videoUrl',
        template: ['isFullBleed', resolveTemplate],
        'container-top-background-color': ['containerTopBackgroundColor', resolveColorName],
        'container-bottom-background-color': ['containerBottomBackgroundColor', resolveColorName],
        'top-spacing': ['topSpacing', resolveSpacingSize],
        'bottom-spacing': ['bottomSpacing', resolveSpacingSize],
        'variant-label': 'datalayerVariant',
      },
    ],
    fallbackDocument: ['fallbackImage', resolveImageReference],
  });

  return <CMSWrapper brProps={brProps} render={MappedVideo} mapping={mapping.current} />;
};

export default VideoCMSWrapper;
